window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector] [type=radio]',
    variantInventory: '.variant-inventory',
    qtyContainer: '.quantity',
    qtyInput: '.quantity__amount'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {

    var self = this;

    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.selectedVariant = this.getSelectedVariant();

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    // Listen to the form submit event
    var form = document.querySelector('.product__form');
    form.addEventListener('submit', this.addProductHandler.bind(this));

    // Slick-ify the images if there are multiple
    if (this.productSingleObject.images.length) {
      // Update image on variant change
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage);

      $(window).on('load', function() {

        // Calculate the heighest slide and set a top/bottom padding for other children.
        // As variableHeight is not supported yet: https://github.com/kenwheeler/slick/issues/1803
        var maxHeight = -1;
        var $thumb = $('.product__thumbnail');
        $thumb.each(function() {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
        });
        $thumb.each(function() {
          var $this = $(this);
          var height = $this.height();
          if (height < maxHeight) {
            $this.css('padding', Math.ceil((maxHeight - height) / 2) + 'px 0');
          }
        });

        // Image sliders
        $('.product__image')
          .on('init', function() {
            // Insert high res background images for zoom
            $('[data-background]', self.$container).each(function() {
              this.style.backgroundImage = 'url('+ this.dataset.background +')';
            });
          })
          // Pause the video when we leave a video slide
          .on('beforeChange', function(e, slick, i) {
            var $slide = slick.$slides.eq(i);
            var video = $slide.find('video').get(0);

            if (video) {
              video.pause();
              video.currentTime = 0;
            }
          })
          // Play the video when we enter video slide
          .on('afterChange', function(e, slick, i) {
            var $slide = slick.$slides.eq(i);
            var video = $slide.find('video').get(0);

            if (video) {
              video.play();
            }
          })
          // Initialise slick on the large image
          .slick({
            slidesToShow: 1,
            fade: true,
            arrows: false,
            swipe: false,
            accessibility: false,
            asNavFor: '.product__thumbnails',
            lazyLoad: 'progressive',
            responsive: [{
              breakpoint: Number(theme.settings.grid_large) - 1,
              settings: {
                arrows: true,
                swipe: true,
                fade: false
              }
            }]
          });

        // Init slick on thumbnails
        $('.product__thumbnails')
          .slick({
            centerMode: true,
            slidesToShow: 4,
            vertical: true,
            focusOnSelect: true,
            arrows: true,
            accessibility: false,
            asNavFor: '.product__image',
            prevArrow: $('.product__thumbnails-arrow--up'),
            nextArrow: $('.product__thumbnails-arrow--down')
          });
      });

      // Load higher quality image
      var $main = this.$container.find('[data-main]');
      var src = $main.attr('src');
      var mainImage = new Image();

      var imgLoaded = function() {
        $main.parent().html(mainImage);
      };

      mainImage.src = src.replace('_150x', '');
      if (mainImage.complete) imgLoaded();
      mainImage.addEventListener('load', imgLoaded, false);

    }

    // zoom
    $('.product__image-container').on('mousemove' + this.namespace, this.zoomProductImage.bind(this));

    // Quantity selector
    var $quantity = $('.quantity');
    var $amount = $quantity.find('.quantity__amount');

    $quantity.on('click', '.quantity__control', function(e) {
      e.preventDefault();

      var amount = Number($amount.val());
      var max = 9999;// Set this to some ridiculous number that no-one would ever purchase

      // Check if shopify is tracking the inventory
      if (self.selectedVariant.inventory_management === 'shopify'
      &&  self.selectedVariant.inventory_policy === 'deny') {
        // Change the max number to the quantity left in shopify
        max = self.selectedVariant.inventory_quantity;
      }

      if (e.currentTarget.className.indexOf('minus') > -1) {
        $amount.val(Math.max(1, amount - 1));
      }
      else if (e.currentTarget.className.indexOf('plus') > -1) {
        $amount.val(Math.min(max, amount + 1));
      }
    });

    // Build product panel
    var $panel = $('.product-panel');
    var $panelImages = $panel.find('.product-panel__images');

    if ($panelImages.find('.product-panel__image').length > 1) {
      var $container = $panel.find('.product-panel__content-container');

      $panelImages
        .on('setPosition', function() {
          if ($(window).width() > Number(theme.settings.grid_medium)) {
            // Update content height
            var imageHeight = $panelImages.height();
            var containerHeight = $container.height();

            $container.css({
              marginTop: ((imageHeight - containerHeight) / 2) +'px'
            });
          }
          else {
            $container.css({
              marginTop: '2rem'
            });
          }
        })
        .slick();
    }

    // make the panel content vertically centered
    var $panelContent = $panel.find('.product-panel__content-container');
    var panelHeight = $panel.height();
    var contentHeight = $panelContent.height();
    if (panelHeight > contentHeight) {
      if(window.innerWidth > theme.settings.grid_large ) {
        $panelContent.css('margin-top', Math.floor((panelHeight - contentHeight) / 2) +'px');
      } else {
        $panelContent.css('margin-top', '30px');
      }
    }
    window.addEventListener('resize', function() {
      if(window.innerWidth < theme.settings.grid_large ) {
        $panelContent.css('margin-top', '30px');
      } else {
        $panelContent.css('margin-top', Math.floor((panelHeight - contentHeight) / 2) +'px');
      }
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     * Added lines 965-967 on aug 26. Allows customer to click through sold out+on stock variants
     */
     updateAddToCartState: function updateAddToCartState(evt) { 
      var variant = evt.variant; 

      if (variant != null) { 
          $(selectors.addToCart).removeAttr('disabled') 
            
      } else { 
          $(selectors.addToCart).attr('disabled', 'disabled') 
      } 

      var hasSelectedSize = false 
      var inventoryQty = inv_qty[variant.id]; 
      var inventoryMsg = ''; 
      this.selectedVariant = variant; 
      var prodInventoryGroup = document.querySelector('.product--check-qty'); 

      var firstOptionVal = $('.variant-group__container[data-optionindex="1"] .variant-group__item input:checked').val(); 
      $('.variant-group__container[data-optionindex!="1"] .normal-option.variant-group__item[data-optionval1!="' + firstOptionVal + '"]').each(function() { 
          $(this).hide(); 
      }); 
      $('.variant-group__container[data-optionindex!="1"] .normal-option.variant-group__item[data-optionval1="' + firstOptionVal + '"]').each(function() { 
          $(this).show(); 
      }); 

      var seen = {}; 
      $('.variant-group__container[data-optionindex!="1"] .pack-size-option.variant-group__item').each(function() { 
          var txt = $(this).text(); 
          if (seen[txt]) { 
              $(this).remove(); 
              $(this).hide() 
          } 
          else { 
              seen[txt] = true; 
              $(this).show() 
          } 
      }); 

      if($('.option-group__size input').length !== 0){ 
          $('.option-group__size input').each(function(){ 
              if( $(this).parent().hasClass('selected') || $(this).is(':checked') ) { 
                  hasSelectedSize = true 
              }  
          }); 
      } 
        
      if (variant.inventory_management == 'shopify') { 
          if (inventoryQty >= 1 && inventoryQty <= 10) { 
              var qtySelector = $('.quantity__amount'); 
              inventoryMsg = '<p>Available, only ' + inventoryQty + ' left.</p>'; 
              if (prodInventoryGroup && hasSelectedSize) {  
                  prodInventoryGroup.style.display = 'block';  
              } 
              if (qtySelector.val() > inventoryQty) { 
                  qtySelector.val(inventoryQty) 
              } 

          } else if (inventoryQty <= 0) { 
              inventoryMsg = '<p>' + $('.out-of-stock-text').html() + '</p>'; 
              if (prodInventoryGroup && hasSelectedSize) { 
                  prodInventoryGroup.style.display = 'none'; 
                  $('#BIS_trigger').show() 
              } 
              if( !hasSelectedSize ) { 
                  $('#BIS_trigger').hide()   
              } 
          } else { 
              if (prodInventoryGroup && hasSelectedSize) { 
                  prodInventoryGroup.style.display = 'block'; 
              } 
              $('#BIS_trigger').hide() 
          } 
      } else { 
          if (prodInventoryGroup && hasSelectedSize) { 
              prodInventoryGroup.style.display = 'block'; 
          } 
      } 

      if (variant.inventory_management == 'shopify' && hasSelectedSize) { 
          if (inventoryQty <= 1) { 
              $(selectors.qtyContainer, this.$container).addClass('disable-qty'); 
              $(selectors.qtyInput, this.$container).prop('disabled', true); 
          } else { 
              $(selectors.qtyContainer, this.$container).removeClass('disable-qty'); 
              $(selectors.qtyInput, this.$container).prop('disabled', false); 
          } 
      } 

      $('.variant-group__variant').each(function() { 
          var formGroup = $(this).parents('.form__group'); 
          if( !formGroup.hasClass('option-group__size') ) { 
              this.innerHTML = variant[this.dataset.option]; 
          } 
      }); 

      var hasSelectedSize = false 
      if($('.option-group__size input').length !== 0){ 
          $('.option-group__size input').each(function(){ 
              if( $(this).parent().hasClass('selected') || $(this).is(':checked') ) { 
                  hasSelectedSize = true 
              }  
          }); 
      } 

      if( hasSelectedSize ) { 

          if (variant) { 
              $(selectors.priceWrapper, this.$container).removeClass('hide'); 
              $(selectors.variantInventory, this.$container).html(inventoryMsg); 
          } else { 
              $(selectors.addToCart, this.$container).prop('disabled', true); 
              $(selectors.addToCartText, this.$container).html(theme.strings.unavailable); 
              $(selectors.priceWrapper, this.$container).addClass('hide'); 
              return; 
          } 

          if (variant.available) { 
              $(selectors.addToCart, this.$container).prop('disabled', false); 
              $(selectors.addToCartText, this.$container).html(theme.strings.addToCart); 
          } else { 
              $(selectors.addToCart, this.$container).prop('disabled', true); 
              $(selectors.addToCartText, this.$container).html(theme.strings.soldOut); 
          } 
      } 

    }, 

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(e) {
      // Match the variant image with the src
      var variant = e.variant;
      var imageUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, 'master');

      var $image = $('.product__image');
      var index = $image.find('[src$="'+ imageUrl +'"]').parents('.product__image-slide').data('slick-index');

      $image.slick('slickGoTo', index);
    },


    getSelectedVariant: function getSelectedVariant() { 
 
      var params = {}; 
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(a, key, val) { 
          params[key] = val; 
      }); 

      var variants = this.productSingleObject.variants; 
      var length = variants.length; 
      var variantId = params.variant ? params.variant : currentVariantID; 
      var currentVariant = '' 

      for (var i = 0; i < length; i++) { 
          if (variants[i].id == variantId) { 
              currentVariant = variants[i]; 
          } 
      } 

      var firstOptionVal = $('.variant-group__container[data-optionindex="1"] .variant-group__item input:checked').val(); 
      $('.variant-group__container[data-optionindex!="1"] .normal-option.variant-group__item[data-optionval1!="' + firstOptionVal + '"]').each(function() { 
          $(this).hide(); 
      }); 
      $('.variant-group__container[data-optionindex!="1"] .normal-option.variant-group__item[data-optionval1="' + firstOptionVal + '"]').each(function() { 
          $(this).show(); 
      }); 

      var seen = {}; 
      $('.variant-group__container[data-optionindex!="1"] .pack-size-option.variant-group__item').each(function() { 
          var txt = $(this).text(); 
          if (seen[txt]) { 
              $(this).remove(); 
              $(this).hide() 
          } 
          else { 
              seen[txt] = true; 
              $(this).show() 
          } 
      }); 
       
      return currentVariant; 
    }, 

    /**
     * Zoom the image on hover
     */
    zoomProductImage: function(e) {

      var container = e.currentTarget;
      var offsetX = e.offsetX || e.touches[0].pageX;
      var offsetY = e.offsetY || e.touches[0].pageY;
      var x = (offsetX / container.offsetWidth) * 100;
      var y = (offsetY / container.offsetHeight) * 100;

      container.style.backgroundPosition = x + '% ' + y + '%';
    },

    /**
     * Handler to add product to cart via ajax request
     */
    addProductHandler: function(e) {

      e.preventDefault();
      if( $('.option-group__size').length >= 1 ) { 
        var hasSelectedSize = false 
        if($('.option-group__size input').length !== 0){ 
          $('.option-group__size input').each(function(){ 
            if( $(this).parent().hasClass('selected') || $(this).is(':checked') ) { 
              hasSelectedSize = true 
            }  
          }); 
        } 
         
        console.log('hasSelectedSize', hasSelectedSize) 

        if(!hasSelectedSize) { 
          //$('.size-validation').show() 
          $('.option-group__size .variant-group__variant').html(` 
              <span class="size-validation desktop" style="display: inline;">Please Select a Size Option</span> 
          `) 

          $('.mobile-validation').html(` 
              <span class="size-validation mobile" style="display: inline;">Please Select a Size Option</span> 
          `) 
          return false 
        } 
      } 

      // Get the basic form data
      var form = e.target;
      var data = {
        id: form.id.value,
        quantity: form.quantity.value
      };

      // Show as loading
      var button = form.add;
      button.classList.add('btn--loading');

      // Look for form items with a name starting with "properties"
      var properties = {};
      var propertyInputs = document.querySelectorAll('[name*="properties"]');
      var length = propertyInputs.length;

      // Push all the found properties into an object
      for (var i = 0; i < length; i++) {
        if (propertyInputs[i].value) {
          var propertyName = propertyInputs[i].name;
          propertyName = propertyName.substring(11, propertyName.length - 1);
          properties[propertyName] = propertyInputs[i].value;
        }
      }

      // If there were properties, attach them to the data to send
      if (Object.keys(properties).length) {
        data.properties = properties;
      }

      // Send the updated cart data
      $.ajax({
        method: 'POST',
        url: form.action,
        data: data,
        success: function() {

          theme.cart.fetchData(function() {
            theme.cart.openCartDrawer();
            theme.cart.updateBadges();
            theme.cart.updateSubtotal();

            // Stop showing as loading
            button.classList.remove('btn--loading');

            var buttonSpan = button.querySelector('span');
            var buttonText = buttonSpan.innerHTML;
            buttonSpan.innerHTML = 'Tilføjet';

            theme.cart.updateCartItems(function() {

              setTimeout(function() {
                buttonSpan.innerHTML = buttonText;
              }, 3000);
            });
          });
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.HeroSlider = (function() {

  /**
	 * Constructor
	 */
  function HeroSlider(container) {

    this.settings = container.dataset.sectionSettings || "{}";
    this.$slider = $(container).find('.slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed,
      speed: (userSettings.slide_speed / 2),
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);

    slideLink(container);
  }

  /**
	 * Event handler that updates the fade setting based on slidesToShow
	 */
  function slideHandler(e) {

    if (e.target.name.indexOf('slidesToShow')) {
      var fade = window.top.document.querySelector('[id$=fade]');

      if (e.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      }
      else {
        fade.checked = true;
        fade.disabled = false;
      }
    }
  }

  /**
   * Event handler for slide to be link
   */
  function slideLink(container) {
    var slides = container.querySelectorAll('.slider__slide-inner');

    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.slideLink) {
        slides[i].classList.add('is-hovered');
        slides[i].addEventListener('click', function() {
          window.location.href = this.dataset.slideLink;
        });
      }
    }
  }

  /**
	 * Shopify section methods
	 */
  HeroSlider.prototype = $.extend({}, HeroSlider.prototype, {

    onSelect: function(e) {
      window.top.addEventListener('input', slideHandler);
      window.top.addEventListener('change', slideHandler);
    },

    onDeselect: function(e) {
      window.top.removeEventListener('input', slideHandler);
      window.top.removeEventListener('change', slideHandler);
    },

    onBlockSelect: function(e) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(e.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    },

    onBlockDeselect: function(e) {
      // Resume carousel
      this.$slider.slick('slickPlay');
    }

  });

  return HeroSlider;
})();

theme.FeaturedCollection = (function() {

  /**
	 * Constructor
	 */
  function FeaturedCollection(container) {

    this.settings = container.dataset.sectionSettings || '{"slidesToShow":4}';
    this.$slider = $(container).find('.slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      accessibility: false,
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider
      .on('setPosition', function() {
        // Reposition arrows based on image heights
        var $this = $(this);
        var $firstImage = $this.find('.slick-active .product-card__image').eq(0);
        var $arrows = $this.find('.slick-arrow');
        $arrows.css('top', $firstImage.height() / 2);
      })
      .slick(sliderSettings);
  }

  return FeaturedCollection;
})();

theme.Testimonials = (function() {

  /**
	 * Constructor
	 */
  function Testimonials(container) {

    this.settings = container.dataset.sectionSettings || "{}";
    this.$slider = $(container).find('.slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed || 2000,
      speed: (userSettings.slide_speed / 2) || 1000,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);
  }

  /**
	 * Event handler that updates the fade setting based on slidesToShow
	 */
  function slideHandler(e) {

    if (e.target.name.indexOf('slidesToShow')) {
      var fade = window.top.document.querySelector('[id="fade"]');

      if (e.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      }
      else {
        fade.checked = true;
        fade.disabled = false;
      }
    }
  }

  /**
	 * Shopify section methods
	 */
  Testimonials.prototype = $.extend({}, Testimonials.prototype, {

    onSelect: function(e) {
      window.top.addEventListener('input', slideHandler);
      window.top.addEventListener('change', slideHandler);
    },

    onDeselect: function(e) {
      window.top.removeEventListener('input', slideHandler);
      window.top.removeEventListener('change', slideHandler);
    },

    onBlockSelect: function(e) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(e.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    },

    onBlockDeselect: function(e) {
      // Resume carousel
      this.$slider.slick('slickPlay');
    }

  });

  return Testimonials;
})();

theme.Banner = (function() {

  function Banner(container) {
    this.settings = container.dataset.sectionSettings || "{}";
    this.$slider = $(container).find('.banner__messages-slideshow');
    this.slideCount = $(container).find('.banner__message');
    var userSettings = JSON.parse(this.settings);

    var defaultSettings = {
      infinite: true,
      arrows: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: userSettings.slide_speed,
      speed: (userSettings.slide_speed / 2)
    }

    var sliderSettings = $.extend(defaultSettings, userSettings);
    if (this.slideCount.length > 1) { // Only initialise slick if there is more than one message :)
      this.$slider.slick(sliderSettings);
    }

  }
  /**
	 * Event handler that updates the fade setting based on slidesToShow
	 */
  function slideHandler(e) {

    if (e.target.name.indexOf('slidesToShow')) {
      var fade = window.top.document.querySelector('[id="fade"]');

      if (e.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      }
      else {
        fade.checked = true;
        fade.disabled = false;
      }
    }
  }

  /**
	 * Shopify section methods
	 */
  Banner.prototype = $.extend({}, Banner.prototype, {

    onSelect: function(e) {
      window.top.addEventListener('input', slideHandler);
      window.top.addEventListener('change', slideHandler);
    },

    onDeselect: function(e) {
      window.top.removeEventListener('input', slideHandler);
      window.top.removeEventListener('change', slideHandler);
    },

    onBlockSelect: function(e) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(e.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    },

    onBlockDeselect: function(e) {
      // Resume carousel
      this.$slider.slick('slickPlay');
    }
  });

  return Banner;

})();

theme.LookbookSingle = (function() {

  function LookbookSingle(container) {

    this.product;
    this.selectedVariant;

    var self = this;

    // Check each lookbook if it needs a carousel
    this.$slider = $(container).find('.lookbook__slider');
    this.$slider.each(function() {
      var $this = $(this);

      if ($this.children().length > 1) {
        $this.slick({
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: window.theme.settings.grid_medium || 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });


    $('.lookbook__collection-images').on('click', 'a', this.updateCollectionProduct.bind(this));

    $('.responsive-video').on('click', this.toggleVideo);

    // wait for the modal to open before we init the product showing
    $(document).on('opened', '.remodal', function () {
      var productContainer = this.querySelector('.lookbook__product--active');
      self.updateProductData(productContainer);
      self.productImageCarousel(productContainer);
      self.selectedVariant = self.product.variants[0];
    });

    // Variant changed
    $('.lookbook__product').on('change', this.updateVariant.bind(this));

    // Submit form
    $('.lookbook__product form').on('submit', this.addProductHandler.bind(this));

    // Quantity selector
    $('.quantity').on('click', '.quantity__control', this.updateQuantities.bind(this));
  }


  LookbookSingle.prototype = $.extend({}, LookbookSingle.prototype, {


    /**
     * Updates product object based on the product showing
     */
    updateProductData: function(productContainer) {
      var productJSON = productContainer.querySelector('[data-product-json]').innerHTML;
      this.product = JSON.parse(productJSON);
    },


    /**
     * Updates the collection product in view inside modal
     */
    updateCollectionProduct: function(e) {
      e.preventDefault();

      var link = e.currentTarget;
      var collection = link.parentElement.parentElement;
      var collectionContainer = collection.parentElement;
      var productId = link.getAttribute('href');

      collection.querySelector('.active').classList.remove('active');
      collectionContainer.querySelector('.lookbook__product--active').classList.remove('lookbook__product--active');

      link.classList.add('active');
      var productContainer = collectionContainer.querySelector('[data-lookbook-product="'+ productId +'"]');
      productContainer.classList.add('lookbook__product--active');

      this.updateProductData(productContainer);
      this.productImageCarousel(productContainer);

      this.updateVariant({ currentTarget: productContainer });
    },


    /**
     * Handles variant slector changing based on radio buttons pressed
     */
    updateVariant: function(e) {

      var self = this;
      var productContainer = e.currentTarget;
      var selected = {};

      // Loop through each radio and gather the checked items
      var options = productContainer.querySelectorAll('[data-single-option-selector] [data-index]');
      for (var i = 0; i < options.length; i++) {
        if (options[i].checked) {
          selected[options[i].name] = options[i].value;
        }
      }

      // Now look over the product variants and match all options and values
      for (i = 0; i < this.product.variants.length; i++) {
        var isMatch = true;

        for (var option in selected) {
          if (this.product.variants[i][option] !== selected[option]) {
            isMatch = false;
          }
        }

        if (isMatch) {
          this.selectedVariant = this.product.variants[i];
          break;
        }
      }

      // Update variant selector
      var variantSelector = productContainer.querySelector('[data-product-select]');
      variantSelector.value = this.selectedVariant.id;

      // Update html
      var price = productContainer.querySelector('.money');
      price.innerHTML = slate.Currency.formatMoney(this.selectedVariant.price, theme.moneyFormat);

      var addBtn = productContainer.querySelector('[data-add-to-cart]');
      if (this.selectedVariant.available) {
        addBtn.innerHTML = '<span>'+ theme.strings.addToCart +'</span>';
        addBtn.removeAttribute('disabled');
      }
      else {
        addBtn.innerHTML = '<span>'+ theme.strings.soldOut +'</span>';
        addBtn.addAttribute('disabled', 'disabled');
      }

      $('.variant-group__variant').each(function() {
        this.innerHTML = self.selectedVariant[this.dataset.option];
      });
    },


    /**
     * Handles updating of quantity based on quantity selector clicked
     */
    updateQuantities: function(e) {
      e.preventDefault();

      var $quantity = $(e.currentTarget).parent();
      var $amount = $quantity.find('.quantity__amount');
      var amount = Number($amount.val());
      var max = 9999;// Set this to some ridiculous number that no-one would ever purchase

      // Check if shopify is tracking the inventory
      if (this.selectedVariant.inventory_management === 'shopify'
      &&  this.selectedVariant.inventory_policy === 'deny') {
        // Change the max number to the quantity left in shopify
        max = this.selectedVariant.inventory_quantity;
      }

      if (e.currentTarget.className.indexOf('minus') > -1) {
        $amount.val(Math.max(1, amount - 1));
      }
      else if (e.currentTarget.className.indexOf('plus') > -1) {
        $amount.val(Math.min(max, amount + 1));
      }
    },


    /**
     * Handles ajax submission of product form
     */
    addProductHandler: function(e) {

      e.preventDefault();

      // Get the basic form data
      var form = e.target;
      var data = {
        id: form.id.value,
        quantity: form.quantity.value
      };

      // Show as loading
      var button = form.add;
      button.classList.add('btn--loading');

      // Send the updated cart data
      $.ajax({
        method: 'POST',
        url: form.action,
        data: data,
        success: function() {
          theme.cart.fetchData(function() {
            button.innerHTML = '<span>Added</span>';
            button.classList.remove('btn--loading');

            theme.cart.updateBadges();
            theme.cart.updateSubtotal();
            theme.cart.updateCartItems(function() {
              button.innerHTML = '<span>'+ theme.strings.addToCart +'</span>';
            });
          });
        },
        error: function(e) {
          console.log(e.status, e.statusText);
          button.innerHTML = '<span>Try again</span>';
          button.classList.remove('btn--loading');

          setTimeout(function() {
            button.innerHTML = '<span>'+ theme.strings.addToCart +'</span>';
          }, 1000);
        }
      });
    },


    /**
     * Initialises the product image carousel once displayed in browser
     */
    productImageCarousel: function(productContainer) {
      var $images = $(productContainer).find('.lookbook__product-images');

      if ($images.length && ! $images.hasClass('slick-initialized')) {
        $images.slick({
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    },


    /**
     * Play/pause the video
     */
    toggleVideo: function() {
      var video = this.querySelector('video');

      if (video.paused) {
        video.parentElement.className = 'responsive-video';
        video.play();
        video.setAttribute('controls', '');
      }
      else {
        video.parentElement.className = 'responsive-video paused';
        video.pause();
        video.removeAttribute('controls');
      }
    }
  });

  return LookbookSingle;
})();

theme.Video = (function() {

  function Video(container) { 
    var iframe = container.querySelector('.responsive-video iframe'); 
    if( document.body.contains(iframe) ) { 
      this.player = new Vimeo.Player(iframe); 
      var wrapper = container.querySelector('.section__video'); 
      if (wrapper) { 
        wrapper.addEventListener('click', this.wrapperClickHandler.bind(this)); 
      } 
    } 
      
  } 

  Video.prototype = $.extend({}, Video.prototype, {

    wrapperClickHandler: function(e) {
      e.currentTarget.classList.add('section__video--played');
      this.player.play();
    }
  });

  return Video;
})();

theme.PageSection = (function() {
	
	/*$(document).ready(function(){
		$('.single-slider').slick({

		});
	})*/
	/**
	 * Constructor
	 */
  function PageSection(container) {


    this.settings = container.dataset.sectionSettings || "{}";
    this.$slider = $(container).find('.single-slider');


    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      accessibility: false,
      dots: true,
      arrows: false,
      autoplay: true
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    // Init slick carousel
    this.$slider.slick(sliderSettings);
   
    
  }

	return PageSection;
})();
theme.ImagePromo = (function() {

/**
   * Event handler for image promo container to be link
   */
  function ImagePromo(container) {

    var imageContainer = container.querySelectorAll('.image-promo-wrapper');
    var textContainer = container.querySelectorAll('.section__content-inner');

    // Needs to handle clicking image or overlay text as well (mobile and desktop layout)
    if (imageContainer[0].dataset.imageLink || textContainer[0].dataset.imageLink) {

      imageContainer[0].parentElement.classList.add('is-hovered');

      imageContainer[0].addEventListener('click', function() {
        window.location.href = this.dataset.imageLink;
      });

      textContainer[0].addEventListener('click', function() {
        window.location.href = this.dataset.imageLink;
      });
    }
  }

  return ImagePromo;
})();


/*================ Modules ================*/
theme.header = {
	/*
	 * Public vars
	 */
  isFixed: false,


  /**
   * The initialising code
   */
  init: function() {

    var self = this;

    // Scroll listener
    window.registerScrollHandler.push(this.scrollHandler.bind(this));
    this.scrollHandler();

    // Menu toggle
    var btnMenu = document.querySelector('.header__btn--menu');
    btnMenu.addEventListener('click', this.btnMenuClickHandler);

    // Menu item toggle
    var navLinks = document.querySelectorAll('.nav__item--has-child:not(.nav__item--account) > a svg');
    navLinks.forEach(function(el) {
      el.addEventListener('click', self.navLinkClickHandler.bind(self));
    });

    // Account toggle when clicked anywhere
    var accountLink = document.querySelector('.header__account .nav__item--has-child');
    accountLink.addEventListener('click', self.accountLinkClickHandler.bind(self));
  },


  /**
   * Window scroll handler, adds class to body if scrolled past banner
   */
  scrollHandler: function() {

    var banner = document.querySelector('.banner');
    var waypoint = banner.offsetHeight || 0;

    // Check if we've scrolled past the banner
		if (window.pageYOffset > waypoint) {
      if (! this.isFixed) {
  			document.body.classList.add('header-fixed');
        this.isFixed = true;
      }
		}
		else {
      if (this.isFixed) {
  			document.body.classList.remove('header-fixed');
        this.isFixed = false;
      }
		}
  },


  /**
   * .header__btn--menu click handler
   */
  btnMenuClickHandler: function() {
    if (document.body.classList.contains('menu-expanded')) {
      document.body.classList.remove('menu-expanded');
    }
    else {
      document.body.classList.remove('search-modal-showing');
      document.body.classList.add('menu-expanded');
    }
  },


  /**
   * .nav__item--has-child > a click handler
   */
  navLinkClickHandler: function(e) {
    e.preventDefault();
    e.currentTarget.parentElement.parentElement.classList.toggle('nav__item--expanded');
  },


  /**
   * .nav__item--has-child > a click handler
   */
  accountLinkClickHandler: function(e) {
    e.currentTarget.classList.toggle('nav__item--expanded');
  }

};

theme.searchModal = function() {
  var bodyEl = document.querySelector('body');
  var banner = document.querySelector('.banner');
  var header = document.querySelector('.header');
  var container = document.querySelector('.search--modal');
  var inner = container.querySelector('.search__inner');
  var $container = $(container);

  updateOffset();

  var form = container.querySelector('form');
  var input = container.querySelector('input[name="q"]');
  // var closeButton = form.querySelector('.search__close');
  // var results = container.querySelector('.search__results .grid');
  //
  // var cachedTerm = '';
  // var currentAjaxRequest = null;

  var searchButton = document.querySelector('.header__btn--search');

  var isShowing = false;
  searchButton.addEventListener('click', toggleModal);

  // input.addEventListener('input', inputHandler);
  form.addEventListener('submit', submitHandler);







  /**
   * Adds margin to search container so it sits under the header
   */
   function updateOffset() {

     var bannerHeight = banner ? banner.clientHeight : 0;
     var headerHeight = header.clientHeight || 0;
     var offset = bannerHeight + headerHeight;

     inner.style.marginTop = offset +'px';

     function resize() {
       bannerHeight = banner ? banner.clientHeight : 0;
       headerHeight = header.clientHeight || 0;
       offset = bannerHeight + headerHeight;

       inner.style.marginTop = offset +'px';
     }

     window.addEventListener("resize", function(){
       resize();
     });

   }

   // document.addEventListener('click', function(event) {

   // if (isShowing) {

   //     var isClickInside = container.contains(event.target);

   //     if (!isClickInside) {
   //       hide();

   //     }


   // }

   // });


  /**
   * Shows the search modal
   */
  function toggleModal() {
    if (isShowing) {
      hide();
    }
    else {
      show();
    }
  }



  /**
   * Shows the search modal
   */
  function show() {

    document.body.classList.remove('menu-expanded');
    document.body.classList.add('search-modal-showing');

    // input.addEventListener('input', inputHandler);
    // closeButton.addEventListener('click', hide);
    // document.addEventListener('keydown', keydownHandler);
    input.addEventListener('focus', termFocusHandler);

    slate.a11y.trapFocus({
      $container: $container,
      namespace: 'container',
      $elementToFocus: $(input)
    });


    setTimeout(function(){
      isShowing = true;
    }, 100);



  }



  /**
   * Hides the search modal
   */
  function hide() {

    document.body.classList.remove('search-modal-showing');

    // input.removeEventListener('input', inputHandler);
    // closeButton.removeEventListener('click', hide);
    // document.removeEventListener('keydown', keydownHandler);
    input.removeEventListener('focus', termFocusHandler);

    slate.a11y.removeTrapFocus({
      $container: $container,
      namespace: 'container'
    });

    isShowing = false;
  }



  // /**
  //  * Handles the search input
  //  */
  // function inputHandler() {
  //
  //   var term = input.value;
  //
  //   if (term.length > 2 && term !== cachedTerm) {
  //     querySearchTerm(term);
  //   }
  //
  //   cachedTerm = term;
  // }
  //
  //
  //
  // /**
  //  * Handles keydown
  //  */
  // function keydownHandler(e) {
  //   switch (e.keyCode) {
  //     //esc
  //     case 27:
  //       hide();
  //       break;
  //   }
  // }



  /**
   * Handles focus on term input
   */
  function termFocusHandler(e) {
    // Select all the text in the search box
    var input = e.target;
    input.setSelectionRange(0, input.value.length);
  }



  // /**
  //  * Ajax request for search term and prints out the results
  //  */
  // function querySearchTerm(term) {
  //   // Encapsulate term in * wildcard to get partial matches
  //   // Hit our json template for search term
  //   var searchURL = '/search?type=product&q=*'+ term +'*';
  //   // Stop any current calls
  //   if (currentAjaxRequest != null) currentAjaxRequest.abort();
  //
  //   currentAjaxRequest = $.getJSON(searchURL +'&view=json', function(data) {
  //     // Reset results.
  //     results.innerHTML = '';
  //
  //     if (data.results_count == 0) {
  //       results.innerHTML = "<div class='grid'><div class='grid__item text-center'><p>No results found.</p></div></div>";
  //     }
  //     else {
  //       for (var i = 0, count = data.results.length; i < count; i++) {
  //         results.innerHTML += data.results[i].markup;
  //       }
  //       // If there are more than 10, let's link to the search results page.
  //       if (data.results_count > 10) {
  //         results.innerHTML += '<p><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></p>';
  //       }
  //     }
  //   });
  // }



  /**
   * Handles the search form submission
   */
  function submitHandler(e) {
    // Wrap search term in wildcards
    e.preventDefault();

    var term = this.q.value;
    var searchURL = '/search?type=product&q=*'+ term +'*';

    window.location = searchURL;
  }



  document.addEventListener("click", function(evt) {

    if (isShowing) {

      var flyoutElement = container,
          targetElement = evt.target;  // clicked element

          do {
            if (targetElement == flyoutElement) {
              return;
            }

            targetElement = targetElement.parentNode;
          } while (targetElement);

          hide();

      }


  });



};

theme.Accordion = (function() {


	/**
	 * Constructor
	 */
	function Accordion(container) {
		// Public vars
		this.container = container;
		this.showingId;
		// Reference to self for use in closures
		var self = this;

		// Add click listeners to each button
		var buttons = container.querySelectorAll('.panel__heading button');
		buttons.forEach(function(el) {
			el.addEventListener('click', self.toggleBody.bind(self));
		});

	}

	/**
	 * Event handler - decides what to show or hide
	 */
	Accordion.prototype.toggleBody = function(e) {

		var bodyId = e.target.dataset.toggle;
		var body = this.container.querySelector('#'+ bodyId);

		// Is something showing?
		if (this.showingId) {
			// Is that something showing the same as what got clicked?
			if (this.showingId === bodyId) {
				this.hideBody(body);
			}
			else {
				var showingBody = this.container.querySelector('#'+ this.showingId);
				this.hideBody(showingBody);
				this.showBody(body);
			}
		}
		else {
			this.showBody(body);
		}
	}

	/**
	 * Event handler - shows a panel body
	 */
	Accordion.prototype.showBody = function(body) {
		body.parents('.panel').classList.remove('collapsed');
		this.showingId = body.id;
	}

	/**
	 * Event handler - hides a panel body
	 */
	Accordion.prototype.hideBody = function(body) {
		body.parents('.panel').classList.add('collapsed');
		this.showingId = null;
	}

	return Accordion;
}());

//
//          modules/product-card.js
//
theme.cart = {
	/*
	 * Public vars
	 */
	isShowing: false,
	data: {},
	currentAjaxRequest: null,
	currentTimeout: null,


	/**
	 * The initialising code
	 */
	init: function() {
		// Reference to this
		var self = this;

		// Cache some DOM elements
		this.cartCount = document.querySelector('.cart-count');
		this.cart = document.querySelector('.cart--drawer');
		this.header = this.cart.querySelector('.cart__header');
		this.btnClose = this.cart.querySelector('.cart__close');
    this.trigger = null;
		this.count = this.cart.querySelector('.cart__count');
		this.countFooter = this.cart.querySelector('.cart__count--footer');
		this.countLabel = this.cart.querySelector('.cart__count-label');
		this.countLabelFooter = this.cart.querySelector('.cart__count-label--footer');
		this.content = this.cart.querySelector('.cart__content');
		this.footer = this.cart.querySelector('.cart__footer');
		this.subtotal = this.cart.querySelector('.cart__subtotal');

		// Build a loader element for later use
		this.loader = document.createElement('div');
		this.loader.className = 'loader';

		// Check if we're on a cart page
		var isCartPage = document.body.classList.contains('template-cart');

		if (isCartPage) {
			// this.addItemListeners();
		}
		else {
			// Initialise ajax cart
			this.updateCartItems();

			// Add listeners to buttons
			var buttonOpen = document.querySelector('.header__btn--cart');
			if (buttonOpen) {
				buttonOpen.addEventListener('click', this.toggleCartDrawer.bind(this));
			}

			this.btnClose.addEventListener('click', function(e) {
				self.closeCartDrawer();
			});

			var fade = document.querySelector('.fade');
			fade.addEventListener('click', this.closeCartDrawer.bind(this));
		}

		this.fetchData();
	},


	/**
	 * Updates the data property with data from cart.js
	 */
	fetchData: function(callback) {
		var self = this;
		$.getJSON('/cart.js', function(data) {
			self.data = data;

			if (callback) callback();
		});
	},


	/**
	 * Send data to /cart/change.js
	 */
  changeData: function(data, callback) {
    var self = this;

    $.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      complete: function(jqxhr, status) {
        self.fetchData(function() {
          self.updateBadges();
          self.updateCartItems();
        });
        if (callback) callback(jqxhr, status);
      }
    });
  },


	/**
	 * Updates the header's cart badge number by the amount passed
	 */
	updateBadges: function() {
    if (this.data.item_count > 0) {
      theme.cart.cartCount.style.display = 'inline';
    }
    else {
      theme.cart.cartCount.style.display = 'none';
    }
    theme.cart.cartCount.innerHTML = theme.cart.count.innerHTML = theme.cart.countFooter.innerHTML = this.data.item_count;
    theme.cart.countLabel.innerHTML = theme.cart.countLabelFooter.innerHTML = this.data.item_count === 1 ? 'Vare' : 'Varer';
	},


	/**
	 * Get's cart html from src/templates/cart.drawer.liquid
	 */
	updateCartItems: function(callback) {
		var self = this;

		$.get('/cart/?view=drawer', function(data) {
			self.content.innerHTML = data;
			self.addItemListeners();

			if (callback) callback();
			$('body').trigger('ajaxCart.afterCartLoad');
		});
	},


	/**
	 * Updates the subtotal
	 */
	updateSubtotal: function() {
		this.subtotal.innerHTML = slate.Currency.formatMoney(this.data.total_price, theme.moneyFormat);
		$('body').trigger('ajaxCart.afterCartLoad');
	},


	/**
	 * Call's appropriate method depending on cart state
	 */
	toggleCartDrawer: function(e) {
    e.preventDefault();

		if (this.isShowing) {
			this.closeCartDrawer();
		}
		else {
			this.openCartDrawer();
		}
	},


	/**
	 * Add class to body so we can animate the cart drawer to the open position
	 */
	openCartDrawer: function() {
		document.body.classList.add('cart-showing');
		this.isShowing = true;

    // Capture the element that opened the cart
    this.trigger = document.activeElement;
    this.btnClose.focus();
	},


	/**
	 * Removes above body class so we can animate the cart drawer to the closed position
	 */
	closeCartDrawer: function() {
		document.body.classList.remove('cart-showing');
		this.isShowing = false;

    // Throw the focus back to the element that opened the cart
    if (this.trigger) {
      this.trigger.focus();
      this.trigger = null;
    }
		// Refresh the cart incase someone changes a quantity without updating
		this.updateCartItems();
	},


	/**
	 * Add event listeners to cart items (eg. buttons, inputs)
	 */
	addItemListeners: function() {
		var self = this;
		var cartItems = document.querySelectorAll('.cart-item');

		cartItems.forEach(function(el) {
			el.querySelector('.cart-item__remove').addEventListener('click', self.removeClickHandler.bind(self));
			el.querySelector('.quantity__control--minus').addEventListener('click', self.minusClickHandler.bind(self));
			el.querySelector('.quantity__control--plus').addEventListener('click', self.plusClickHandler.bind(self));
		});
	},


	/**
	 * Handles a user remove update event
	 */
	removeClickHandler: function(e) {

    e.preventDefault();

		var self = this;

    var target = e.currentTarget;
    var cartItem = target.parents('.cart-item');

    // update the line item quantity
    var line = Number(target.dataset.line);
    var quantity = this.data.items[line].quantity;
    this.data.items[line].quantity = 0;

    // update the badge counts
    this.data.item_count -= quantity;
    this.updateBadges();

    // Update subtotal
    this.data.total_price -= this.data.items[line].price;
    this.updateSubtotal();

    cartItem.classList.add('removed');

  	// debounce the ajax call
		this.currentTimeout = setTimeout(function() {

      self.changeData({
        quantity: 0,
        line: (line + 1)
      });

		}, 500);
  },


	/**
	 * Handles a user quantity update event - could be made DRYer with below method
	 */
	minusClickHandler: function(e) {

    e.preventDefault();

    // Clear the timeout if it is set
		if (this.currentTimeout) clearTimeout(this.currentTimeout);

		var self = this;

    var target = e.currentTarget;
    var cartItem = target.parents('.cart-item');
		var input = cartItem.querySelector('.quantity__amount');

    // update the line item quantity
    var line = Number(target.dataset.line);
    var quantity = this.data.items[line].quantity - 1;
    input.value = quantity;
    this.data.items[line].quantity = quantity;

    // update the badge counts
    this.data.item_count -= 1;
    this.updateBadges();

    // Update subtotal
    this.data.total_price -= this.data.items[line].price;
    this.updateSubtotal();

    if (quantity < 1) {
      cartItem.classList.add('removed');
    }

  	// debounce the ajax call
		this.currentTimeout = setTimeout(function() {

      self.changeData({
        quantity: quantity,
        line: (line + 1)
      });

		}, 500);

  },


	/**
	 * Handles a user quantity update event
	 */
	plusClickHandler: function(e) {

    e.preventDefault();

    // Clear the timeout if it is set
		if (this.currentTimeout) clearTimeout(this.currentTimeout);

		var self = this;

    var target = e.currentTarget;
    // Exit if disabled
    if (target.classList.contains('quantity__control--disabled')) return;

    // TODO let user know if item is last of stock

    var cartItem = target.parents('.cart-item');
		var input = cartItem.querySelector('.quantity__amount');

    // update the line item quantity
    var line = Number(target.dataset.line);
    var quantity = this.data.items[line].quantity + 1;

    input.value = quantity;
    this.data.items[line].quantity = quantity;

    // update the badge counts
    this.data.item_count += 1;
    this.updateBadges();

    // Update subtotal
    this.data.total_price += this.data.items[line].price;
    this.updateSubtotal();

  	// debounce the ajax call
		this.currentTimeout = setTimeout(function() {

      self.changeData({
        quantity: quantity,
        line: (line + 1)
      });

		}, 500);
  }
};

theme.footer = {
  init: function() {
    var self = this;
    $('footer .nav--level-one > .nav__item').on('click', function(e) {
      e.preventDefault();
      if (window.theme.settings.grid_small < $(window).width()) {
        // No accordion on desktop! :)
        return false;
      }
      $(this).find('.menu__expander').toggleClass('menu__expander--expanded');
      $(this).find('.nav--level-two').slideToggle('slow');
    });

    $('footer .nav--level-two > .nav__item').on('click', function(e) {
      e.stopPropagation();
    });


    // Homepage newsletter action to connect to Klaviyo
    $(".newsletter__input--homepage").on('blur', function(e) {
      e.preventDefault();
      var email = $(this).val();
      var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://manage.kmail-lists.com/subscriptions/external/subscribe",
          "method": "POST",
          "headers": {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          "data": {
              "g": "QsYEeJ",
              "$fields": "$source",
              "email": email,
              "$source": "Homepage"
          }
      };
      $.ajax(settings).done(function (response) {
          console.log(response);
      });
    });

    // Footer newsletter action to connect to Klaviyo
    $(".newsletter__input--footer").on('blur', function(e) {
      e.preventDefault();
      var email = $(this).val();
      var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://manage.kmail-lists.com/subscriptions/external/subscribe",
          "method": "POST",
          "headers": {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          "data": {
              "g": "QsYEeJ",
              "$fields": "$source",
              "email": email,
              "$source": "Footer"
          }
      };
      $.ajax(settings).done(function (response) {
          console.log(response);
      });
    });
  }
}

// =require modules/currencies.js
theme.collectionList = {

  init: function() {
    $('.collection-slider').slick({
      centerMode: true,
      arrows: false
    });
  }
};

theme.Tabs = (function() {


  /**
   * Constructor
   * @param       {element} container The tabs container element
   * @constructor
   */
  function Tabs(container) {

    // Public vars
    this.container = container;
    this.tabs = container.querySelectorAll(':scope > .tabs__tabs button');
    this.panels = container.querySelectorAll(':scope > .tabs__panels > .tabs__panel');

    // Reference to self for use in closures
    var self = this;

    // Add click listeners to each button
    this.tabs.forEach(function(el) {
      el.addEventListener('click', self.tabClickHandler.bind(self));
    });
  }


  /**
   * Event handler that hides/shows tab panels
   * @param  {object} e The event object
   */
  Tabs.prototype.tabClickHandler = function(e) {
    // Pull the toggle id out of element attribute
    var toggle = e.currentTarget.dataset.toggle;

    // Loop through tabs add/remove active class
    this.tabs.forEach(function(el) {
      if (el === e.currentTarget) {
        el.parentElement.classList.add('tabs__tab--active');
      }
      else {
        el.parentElement.classList.remove('tabs__tab--active');
      }
    });

    // Loop through panels add/remove active class
    this.panels.forEach(function(el) {
      if (el.id === toggle) {
        el.classList.add('tabs__panel--active');
      }
      else {
        el.classList.remove('tabs__panel--active');
      }
    });
  };

  function wrap(el, wrapper, selector, identifier) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.classList.add(selector);
      wrapper.id = 'tableloop_' + identifier;
      wrapper.appendChild(el);
  }





  $(document).ready(function(){

    var sizeTables = document.querySelectorAll('.tabs__panel-content table');

    if (sizeTables.length > 0) {


      for (var i=0, n=sizeTables.length; i < n; i++) {

        var $table = $(sizeTables[i]);
        var $wrapper = $(this).parents().closest('.table-wrapper');
        console.log($wrapper);

        wrap(sizeTables[i], document.createElement('div'), 'table-wrapper', i);
        wrap(sizeTables[i], document.createElement('div'), 'table-scroll', '');

        $table.clone( true ).appendTo('#tableloop_' + i).addClass('clone');

      }

      


      
    }
  });
  
 

  return Tabs;
}());

theme.ResponsiveTable = (function() {


  /**
   * ResponsiveTable constructor
   * @param       {element} container the table element
   * @constructor
   */
  function ResponsiveTable(container) {

    // Public vars
    this.container = container;
    this.header = this.getHeaderArray();
    this.buildRows();
  }


  /**
   * Create an array out of each th element's text
   */
  ResponsiveTable.prototype.getHeaderArray = function() {

    var header = [];
    var thead = this.container.querySelector(':scope > thead');

    if (thead) {
      thead.querySelectorAll('th').forEach(function(th) {
        header.push(th.innerText.trim());
      });
    }

    return header;
  };


  /**
   * Add class name and data attribute to each row and td based on header text
   */
  ResponsiveTable.prototype.buildRows = function() {

    var self = this;
    var tbody = this.container.querySelector(':scope > tbody');

    tbody.querySelectorAll('tr').forEach(function(tr) {
      tr.classList.add('responsive-table-row');

      tr.querySelectorAll(':scope > td').forEach(function(td, i) {
        td.setAttribute('data-label', self.header[i]);
      });
    });
  };

  return ResponsiveTable;
}());

// =require modules/table-fixed-col.js

/*================ Templates ================*/
theme.article = function() {

  // fix the social sharing icons on scroll
  var social = document.querySelector('.article__social');
  if (social) {
    var $window = $(window);
    $window.on('load', function() {
      var headerHeight = document.querySelector('.header').offsetHeight;
      var article = document.querySelector('.article__body');
      var articleTop = article.offsetTop;
      var articleHeight = article.offsetHeight;
      var bottom = articleTop + articleHeight - social.offsetHeight;

      $window
        .on('scroll', function() {
          // Test if mobile
          if ($window.width() > Number(theme.settings.grid_medium)) {
            var scrollTop = $(window).scrollTop();

            // Test if past top
            if (scrollTop + headerHeight > articleTop) {
              // Test if past bottom
              if (scrollTop + headerHeight > bottom) {
                social.style.position = 'absolute';
                social.style.top = 'auto';
                social.style.bottom = '0';
                social.style.left = '0';
              }
              else {
                social.style.position = 'fixed';
                social.style.top = headerHeight + 'px';
                social.style.left = 'auto';
              }
            }
            else {
              social.removeAttribute('style');
            }
          }
        })
        .trigger('scroll');
    });
  }

  // Init slick carousel
  $('.article__products-inner')
    .on('setPosition', function() {
      // Reposition arrows based on image heights
      var $this = $(this);
      var $firstImage = $this.find('.slick-active .product-card__image').eq(0);
      var $arrows = $this.find('.slick-arrow');
      $arrows.css('top', $firstImage.height() / 2);
    })
    .slick({
      slidesToShow: 4,
      accessibility: false,
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });



  // slick carousel on related articles
  $('.article__stories')
    .on('setPosition', function() {
      // Reposition arrows based on image heights
      var $this = $(this);
      var $firstImage = $this.find('.slick-active .article-card__image').eq(0);
      var $arrows = $this.find('.slick-arrow');
      $arrows.css('top', $firstImage.height() / 2);
    })
    .slick({
      slidesToShow: 4,
      accessibility: false,
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

};

theme.collection = function() {

  var collection = document.querySelector('.collection');
  var collectionList = collection.querySelector('.collection__list');

  var sort = document.querySelector('#sort-by');
  sort.addEventListener('change', sortHandler);


  var btnMore = document.querySelector('#btn-more');
  if (btnMore) btnMore.addEventListener('click', moreHandler);


  /**
   * Updates the url with the sort query
   */
  function sortHandler(e) {
    e.preventDefault();
    collection.classList.add('collection--loading');
    window.location.href = '?sort_by='+ sort.value;
    console.log("sort handler");
  }

  function checkMore() {
    var url = btnMore.href;
    $.get(url +'&view=products', function(res) {
      if (res.indexOf('there are no products') > -1) {
        btnMore.classList.add('hide');
      }
    });
  }


  /**
   * Fetches more products for the page
   */
  function moreHandler(e) {
    e.preventDefault();

    var url = btnMore.href;
    var regex = /(page=)([0-9]+)/;
    var pageMatch = url.match(regex);
    var nextPage = Number(pageMatch[2]) + 1;

    // Show loading
    btnMore.classList.add('btn--loading');

    // fetch the next page
    $.get(url +'&view=products', function(res) {
      if (res.indexOf('there are no products') > -1) {
        // There are no more products
        btnMore.classList.add('hide');
      }
      else {
        collectionList.innerHTML += res;
        var splitUrl = url.split(regex);
        splitUrl[2] = nextPage;
        // Update page number in href
        btnMore.href = splitUrl.join('');

        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }
      checkMore();
      btnMore.classList.remove('btn--loading');

    });
  }
};

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.collectionSlider = {
  init: function() {

$('.underwear__gallery').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
    
  }
}

theme.collectionFeaturedSlider = {
  init: function() {

    $('.collection-carousel')
      .on('init', playVideos)
      .on('afterChange', playVideos)
      .on('setPosition', function() {
        // Reposition arrows based on image heights
        var $this = $(this);
        var $firstImage = $this.find('.slick-active .product-card__image').eq(0);
        var $arrows = $this.find('.slick-arrow');
        $arrows.css('top', $firstImage.height() / 2);
      })
      .slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4
            }
          }
        ]
      });

    function playVideos() {

      $('.slick-active').each(function() {

        var video = this.querySelector('video');

        if (video && video.paused) {
          video.play();
        }
      });
    }
  }
};

theme.promotionFeaturedSlider = {
  init: function() {

  $('.promotion-carousel').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });

    
  }
}


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('hero-slider', theme.HeroSlider);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('banner', theme.Banner);
  sections.register('lookbook-single', theme.LookbookSingle);
  sections.register('video', theme.Video);
  sections.register('page', theme.PageSection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('image-promo', theme.ImagePromo);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Run our theme scripts
  if (theme.template) {
    if (theme.template.hasHeader) {
      theme.header.init();
      theme.searchModal();
    }

    if (typeof theme[theme.template.name] === 'function') {
      theme[theme.template.name]();
    }

    if (theme.template.hasCart) {
      theme.cart.init();
    }

    theme.footer.init();
  }

  // Accordions
  document.querySelectorAll('.accordion').forEach(function(el) {
    new theme.Accordion(el);
  });

  // Tabs
  document.querySelectorAll('.tabs').forEach(function(el) {
    new theme.Tabs(el);
  });

  // Product cards
  // document.querySelectorAll('.product-card').forEach(function(el) {
  //   new theme.ProductCard(el);
  // });

  document.querySelectorAll('.responsive-table').forEach(function(el) {
    new theme.ResponsiveTable(el);
  });

  // Collection Underwear Slider
  theme.collectionSlider.init();

  // Collection Featured Slider
  theme.collectionFeaturedSlider.init();

  // Collection List Slider
  theme.collectionList.init();

  // Promotion Featured Slider
  theme.promotionFeaturedSlider.init();

  $readMoreJS.init({
    target: '.truncate',
    numOfWords: 40,
    toggle: true,
    moreLink: '+',
    lessLink: '-'
  });

  $('.floating-label__input').each(function(){
    var text_value = $(this).val();
    if (text_value !== '') {
      $(this).closest('.floating-label').addClass('input--not-empty');
    }
  });

  $('.floating-label__input').on('input', function() {
    var $field = $(this).closest('.floating-label');
    if (this.value) {
      $field.addClass('input--not-empty');
    } else {
      $field.removeClass('input--not-empty');
    }
  });
});